import { Field, ObjectType } from 'type-graphql'

@ObjectType()
export class DbRestoreOutputEvent {
  @Field(() => String, { nullable: false })
  line: string
}
